import React from 'react'
import LandingImg from '../assets/sample_homepage.jpg'
import LogoImg from '../assets/tcls_logo1.png'


export default function Landing() {
  return (
    <div>
      <br></br>
      <svg viewBox="0 0 1440 780" xmlns="http://www.w3.org/2000/svg">

        <image href={LandingImg} width="1440" height="780" />
        <a href="/pta" >
            <polygon points="884,452 970,452 1014,526 970,602 884,602 840,526" fill="transparent" class="map-area" id="pta"/>  
        </a>

        <a href="/school-calendar" >
            <polygon points="1164,452 1254,452 1296,526 1254,602 1168,602 1122,526" fill="transparent" class="map-area" id="calendar"/>  
        </a>

        <a href="/registration" >
            <polygon points="1024,368 1114,368 1158,444 1114,522 1028,522 982,444" fill="transparent" class="map-area" id="enrollment"/>  
          </a>

          <a href="/newsletter" >
              <polygon points="1028,534 1114,534 1158,614 1114,688 1028,688 982,614" fill="transparent" class="map-area" id="newsletter"/>  
          </a>

          <a href="/home" >
              <polygon points="422,318 610,318 634,342 610,368 422,368 400,342" fill="transparent" class="map-area" id="learnmore"/>  
          </a>

      </svg>

    </div>
  )
}
